export default "__VITE_ASSET__C6i3UHvh__"